'use strict';
angular
    .module('websiteToBeCompiledNewsModule', ['visualChooseModule', 'initWebsiteNewsModule', 'ngFileUpload'])
    .controller('editingCenterWebsiteNewsCtrl', [
        '$scope',
        'beforeonload',
        '$element',
        '$compile',
        '$window',
        '$filter',
        '$location',
        '$anchorScroll',
        '$q',
        '$state',
        '$validation',
        '$timeout',
        'trsHttpService',
        'initWebsiteDataService',
        'modalDialog',
        'jsonArrayToStringService',
        'websiteService',
        'trsspliceString',
        '$sce',
        'initSingleSelecet',
        'initeditctrBtnsService',
        'filterEditctrBtnsService',
        'initWebsiteNewsService',
        'trsSelectDocumentService',
        'Upload',
        'websiteBtnService',
        'iWoService',
        'editingCenterService',
        'storageListenerService',
        'ueditorService',
        'editIsLock',
        'editcenterRightsService',
        'sensitiveWordCheckService',
        'editingMediatype',
        'globleParamsSet',
        'newMediaService',
        'websiteConst',
        'messagePublishService',
        function (
            $scope,
            beforeonload,
            $element,
            $compile,
            $window,
            $filter,
            $location,
            $anchorScroll,
            $q,
            $state,
            $validation,
            $timeout,
            trsHttpService,
            initWebsiteDataService,
            modalDialog,
            jsonArrayToStringService,
            websiteService,
            trsspliceString,
            $sce,
            initSingleSelecet,
            initeditctrBtnsService,
            filterEditctrBtnsService,
            initWebsiteNewsService,
            trsSelectDocumentService,
            Upload,
            websiteBtnService,
            iWoService,
            editingCenterService,
            storageListenerService,
            ueditorService,
            editIsLock,
            editcenterRightsService,
            sensitiveWordCheckService,
            editingMediatype,
            globleParamsSet,
            newMediaService,
            websiteConst,
            messagePublishService
        ) {
            initStatus();
            initData();
            websiteService.addFuture($scope, ['sendmessage']);

            /**
             * [initStatus 初始化状态]
             *
             * @return  {[type]}
             *   [return description]
             */
            function initStatus() {
                $scope.news = false;
                $scope.address = true;
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                };
                $scope.status = {
                    newsFormError: [],
                    websiteAscription: $state.params.wzmetadataid === undefined ? 'false' : 'true',
                    switch: 'manuscriptInfo', // 默认选中稿件信息
                    siteid: $state.params.wzsiteid,
                    chnldocid: $state.params.wzchnldocid,
                    openBtn: true,
                    isCheckSensitiveWords: false,
                    zhengwen: false,
                    support: {
                        content: '', // 提交给辅助写作的纯文本
                    },
                    files: [], // 上传附件绑定数组
                    showFiles: [], // 附件展示以及上传字段
                    isUploaderFile: false, // 上传按钮是否可点击
                    isSubTitleShow: true, // 是否显示副标题
                    hideOrMoreText: true, // 显示隐藏或者更多操作
                    showRelated: false, // 关联延展阅读单选框
                    relatedContent: false, // 关联延展阅读内容
                    hasTimeline: false, // 是否存在流程版本
                    isEditDraft: !!angular.isDefined($state.params.wzchnldocid), // 是否是编辑稿件
                    bigFaceSwitch: {
                        status: false,
                    },
                    sensitiveWordTit: '敏感词校验',
                    heimaCheckTit: '错别字校对',
                    position: $state.params.wzplatform, // 稿件状态
                    audioVideoidsArray: [], // 播放音视频临时数组
                    showVideoAudioDiv: false, // 初始化音视频所需的div
                    isFusionEditor: $state.current.name === 'fusionnews', // 是否来自融合编辑器
                    showAddimg: false,
                    isSecondReview: false, // 二次审签
                    isawaitrevise: $state.params.isawaitrevise,
                    mediaType: editingMediatype.website,
                    wzmetadataid: $state.params.wzmetadataid,
                    pictureSize: '',
                    picRatio: 0
                };
                $scope.data = {
                    userName: '',
                    additionalText: [], // 内容拓展
                    relNewsSelectedItems: [],
                    selectNewArray: [],
                    selectTagArray: [],
                    ownerSelectedItems: '',
                    KEYWORDS: [],
                    version: [],
                    copyVersion: [],
                    specialDoc: 0,
                    trench: websiteConst.listenStroageKey,
                    tag: {
                        hasChoose: false,
                        originalTag: [],
                        selectTag: [],
                    },
                    comment: {
                        comment: [],
                        voiceObj: {},
                        hasMore: false,
                        currPage: 1,
                    },
                    moveMethodName: {
                        0: 'moveDAIBIANDoc',
                        1: 'moveDAISHENDoc',
                        2: 'moveYIQIANFADoc',
                    },
                    path: {
                        '-1': 'editingCenterFusionPersonalVersionTime',
                        '1': 'editingCenterAppPersonalVersionTime',
                        '2': 'editingCenterWebsitePersonalVersionTime',
                        '3': 'editingCenterPaperPersonalVersionTime',
                        '4': 'editingCenterWeixinPersonalVersionTime',
                    },
                    versionName: {
                        '-1': 'iwoobjectversionid',
                        '1': 'appobjectversionid',
                        '2': 'wzobjectversionid',
                        '3': 'bzobjectversionid',
                        '4': 'wxobjectversionid',
                    },
                    selectedVideoArray: [], // 选择的视频
                };
                if ($scope.status.isFusionEditor) {
                    $scope.params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'getWebFusionDoc',
                        sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                    };
                } else {
                    $scope.params = {
                        serviceid: 'mlf_website',
                        methodname: 'getNewsDoc',
                        ChnlDocId: $state.params.wzchnldocid,
                        ChannelId: $state.params.wzchannelid,
                        SiteId: $state.params.wzsiteid,
                        MetaDataId: $state.params.wzmetadataid,
                    };
                }
                $scope.otherAreaState;
                // 判断流程版本的存在与否
                $anchorScroll.yOffset = 63;
                // 上传音视频
                emitCloseWindow();
                $scope.editFlag = {
                    media: 'website',
                    docType: 'news',
                };
            }

            /**
             * [theFormError description] 获取表单变化
             * @return {[type]} [description]
             */
            $scope.theFormError = function () {
                // 当表单发生变化时会进入方法
                var errorArray = [];
                for (var error in $scope.newsForm.$error) {
                    errorArray.push(error);
                }
                $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
                if ($scope.status.newsFormError.length != errorArray.length) {
                    // 长度不相等说明表单errorname发生变化
                    $scope.status.newsFormError = errorArray;
                }
                return $scope.status.newsFormError; // 返回
            };

            /**
             * [toggleEditor description] 切换编辑器显隐
             * @return {[type]} [description]
             */
            $scope.toggleEditor = function () {
                $scope.status.zhengwen = !$scope.status.zhengwen;
                if ($scope.status.zhengwen) {
                    // 隐藏编辑器
                    $('.body_manuscript_content').addClass('editorHidden');
                } else {
                    $('.body_manuscript_content').removeClass('editorHidden');
                }
            };

            /**
             * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
             * @return {[type]} [description]
             */
            function emitCloseWindow() {
                editingCenterService.allAppCloseWindow($scope, { typeName: 'website', saveLocal: true });
            }

            /**
             * [initData description]初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                $scope.status.showVideoAudioDiv = false;
                $scope.handleBtnClick = function (funname) {
                    eval('$scope.' + funname + '()');
                };
                // 判断是否有修订完成权限
                if ($scope.status.isawaitrevise) {
                    editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                        $scope.status.btnRights = rights;
                    });
                }
                if (!$scope.status.isFusionEditor) {
                    (angular.isDefined($state.params.wzchnldocid) ? initEditData() : initNewData()).then(function () {
                        beforeonload.beforeonloadAlert($scope); // 关闭窗口监听，检查页面是否修改，让用户确认是否保存
                        editingCenterService.initAppendixUpload($scope);
                    });
                }
                // 融合编辑器下获取评审意见
                if ($state.params.iwometadataid) {
                    getComment($state.params.iwometadataid, $scope.data.comment.currPage);
                }
                // editcenterRightsService.initIwoListBtn("website.trace").then(function(data) {
                //     $scope.status.bigFaceRights = data;
                // });

                // 非融合编辑器的裁剪功能
                getCutPictureWidthHeight();
                storageListenerService.removeListener('website');
                // getDefaultSources();
            }

            /**
             * [initEditData description]初始化编辑数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            function initEditData(dealWithListFun) {
                var defer = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get').then(function (data) {
                    $scope.list = data;
                    $scope.data.remarks = data.REMARKS;
                    $scope.data.SPECIALDOC = $scope.list.SPECIALDOC;
                    $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                    resolveOUTLINEPIC(); // 编辑稿件时添加加号
                    document.title = $scope.list.TITLE = $scope.list.TITLE.split('<br />').join('\n');
                    reWriteAttachFile(data);
                    $scope.data.initContent = angular.copy(data.HTMLCONTENT); // 初始化正文，用于后面比较正文是否被修改过（特殊处理）
                    $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                    showAdditionalText();
                    initDocgenre(data);
                    template($state.params.wzchannelid).then(function (dataC) {
                        angular.isDefined($state.params.wzmetadataid) ? '' : ($scope.websiteTemplate = dataC[0]);
                        $scope.list.TEMPNAME = {
                            name: data.TEMPNAME.NAME,
                            value: data.TEMPNAME.VALUE,
                        };
                        $scope.list.TEMPID = $scope.list.TEMPNAME.value;
                    });
                    initBtnArray();
                    getChannel();
                    initKeyWords();
                    // 初始化责任编辑
                    getCurrentLoginUser().then(function (name) {
                        $scope.list.EDITORTRUENAME = $scope.list.EDITORTRUENAME ? $scope.list.EDITORTRUENAME : name[0].TRUENAME;
                    });
                    // 请求这个稿件的标签
                    getCurrDraftTag();
                    // 获取评审意见
                    if (!$state.params.iwometadataid) {
                        getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
                    }
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    // 获取流程版本
                    getVersion()
                        .then(function (data) {
                            return loadDirective();
                        })
                        .then(function () {
                            $scope.status.showVideoAudioDiv = true;
                            defer.resolve();
                        });
                });
                // 稿件加锁
                editIsLock.lockDraft($state.params.wzmetadataid);
                return defer.promise;
            }

            /**
             * [initNewData description]初始化新建数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            function initNewData(dealWithListFun) {
                var defer = $q.defer();
                $scope.list = initWebsiteDataService.initNews();
                initKeyWords();
                $scope.list.AUDIOVIDEO = []; // 将音视频文件转换为数组格式
                $scope.list.CHANNELID = $state.params.wzchannelid;
                $scope.data.initContent = angular.copy($scope.list.HTMLCONTENT); // 初始化正文，用于后面比较正文是否被修改过（特殊处理）
                initDocgenre();
                initBtnArray();
                getChannel();
                getCurrentLoginUser().then(function (data) {
                    $scope.list.EDITORTRUENAME = data[0].TRUENAME;
                });
                template($state.params.wzchannelid).then(function (dataC) {
                    angular.isDefined($state.params.wzmetadataid) ? '' : ($scope.websiteTemplate = dataC[0]);
                    $scope.list.TEMPID = $scope.list.TEMPNAME.value;
                });
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                loadDirective().then(function () {
                    $scope.status.showVideoAudioDiv = true;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getCutPictureWidthHeight description]获取图片编辑默认宽高
             * @return {[type]} [description]
             */
            function getCutPictureWidthHeight() {
                editingCenterService.querySettedPicSize('website').then(function (data) {
                    $scope.status.pictureSize = websiteService.resetPicSize(data.OutLinePicSize);
                });
            }

            /**
             * [resolveOUTLINEPIC description]编辑稿件时添加加号
             *
             * @return  {[type]}  [return description]
             */
            function resolveOUTLINEPIC() {
                if (!$scope.list.OUTLINEPICS) {
                    $scope.list.OUTLINEPICS = [];
                }
                $scope.list.OUTLINEPICS.push({
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                });
            }

            /**
             * [initDocgenre description]初始化稿件体裁
             *
             * @param   {[type]}  obj  [obj description]
             *
             * @return  {[type]}       [return description]
             */
            function initDocgenre(obj) {
                iWoService.initData().then(function (data) {
                    $scope.docgenre = data.DocGenre;
                    $scope.list.DOCGENRE = angular.isDefined(obj) ? obj.DOCGENRE : angular.copy($scope.docgenre[0]);
                });
            }

            $scope.invalidTag = function (tag) {
                var reg = /^[^<>\/;]*$/;
                if (tag.name.length > 20) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '单个关键词长度不能超过20！';
                }
                if (!reg.test(tag.name)) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '不能包含特殊字符！';
                }
            };
            $scope.checkTag = function (tag) {
                var len = $scope.data.KEYWORDS.length;
                if (len == 10) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '关键词个数不能超过10个！';
                    return false;
                } else {
                    $scope.keywordsTips = '';
                    $scope.isShowKeywordTips = false;
                }
                if (tag.name.indexOf(' ') > -1) {
                    var spaceArr = tag.name.split(' ');
                    $timeout(function () {
                        $scope.data.KEYWORDS.pop();
                        var containArr = [];
                        for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                            containArr.push($scope.data.KEYWORDS[j].name);
                        }
                        for (var i = 0; i < spaceArr.length; i++) {
                            if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                                $scope.data.KEYWORDS.push({
                                    name: spaceArr[i],
                                });
                                containArr.push(spaceArr[i]);
                            }
                        }
                    });
                }
            };
            $scope.leave = function () {
                // $scope.isShowKeywordTips = false;
            };
            $scope.enter = function () {
                var reg = /^[^<>\/]*$/;
                if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                    $scope.isShowKeywordTips = true;
                }
            };

            // 新增稿源
            $scope.saveReleaseSource = function () {
                $scope.params = {
                    serviceid: 'mlf_website',
                    methodname: 'saveReleaseSource',
                    siteid: $scope.status.siteid,
                    SrcName: $scope.SrcName,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'post').then(function (data) {
                    if (data.TYPE == 3) {
                        modalDialog.alertType('新增稿源', '', 'success', false);
                        requestData(function () {
                            $scope.params = {
                                serviceid: 'mlf_website',
                                methodname: 'getReleaseSource',
                            };
                            initSingleSelecet.websiteSource().then(function (data) {
                                $scope.sourceJson = data;
                                $scope.websiteSource = angular.copy($scope.sourceJson[0]);
                            });
                        });
                    }
                    if (data.TYPE == 5) {
                        modalDialog.alertType('新增稿源', '该名字已存在稿源库中，请重新命名', 'error', 'confirm');
                    }
                });
            };

            /**
             * [requestData 自定义请求数据]
             *
             * @param  {[function]}  callback
             *   [callback 回调函数]
             *
             * @return  {[type]}
             *   [return undefined]
             */
            function requestData(callback) {
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get').then(function (data) {
                    if (angular.isFunction(callback)) {
                        callback(data);
                    } else {
                        $scope.items = data.DATA;
                    }
                });
            }

            // 点击模板请求
            $scope.websiteTemplateFn = function () {
                $scope.list.TEMPID = $scope.list.TEMPNAME.value;
            };

            /**
             * [updateCKSelection description]trsCheckBox的回调函数
             * @param  {[str]} attribute [description]需要改变的属性
             * @return {[type]}           [description]
             */
            $scope.updateCKSelection = function (attribute) {
                $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
            };

            // 锚点定位
            $scope.goto = function (id) {
                $location.hash(id);
                $anchorScroll();
            };

            // 时间轴测试数据
            $scope.timelineTestData = {
                day: new Date(),
                time: new Date(),
            };

            // 组装关键词为数组开始
            $scope.delete = function (record) {
                $scope.list.KEYWORDS.splice(record, 1);
            };

            // 点击隐藏副标题
            $scope.subTitleHide = function () {
                $scope.status.isSubTitleShow = false;
                $scope.status.hideOrMoreText = false;
            };

            // 点击显示副标题
            $scope.subTitleShow = function () {
                $scope.status.isSubTitleShow = true;
                $scope.status.hideOrMoreText = true;
            };
            // 显示关联阅读延展
            $scope.selectRelated = function () {
                $scope.status.showRelated = !$scope.status.showRelated;
                $scope.status.relatedContent = !$scope.status.relatedContent;
            };

            /**
             * [initKeyWords 初始化关键词]
             *
             * @return  {[type]}
             *   [return description]
             */
            function initKeyWords() {
                if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
                    var KEYWORDS = $scope.list.KEYWORDS.split(';');
                    $scope.data.KEYWORDS = [];
                    angular.forEach(KEYWORDS, function (data, index, array) {
                        $scope.data.KEYWORDS.push({
                            name: data,
                        });
                    });
                } else {
                    $scope.data.KEYWORDS = [];
                }
            }
            // 内容拓展
            $scope.contentExpansion = function () {
                websiteService.contentExpansion($scope.list, function (data) {
                    $scope.list.ADDITIONALTEXTTOP = data.AdditionalTextTop;
                    $scope.list.ADDITIONALTEXTBOTTOM = data.AdditionalTextBottom;
                    $scope.list.ADDITIONALTEXTLEFT = data.AdditionalTextLeft;
                    $scope.list.ADDITIONALTEXTRIGHT = data.AdditionalTextRight;
                    showAdditionalText();
                });
            };

            /**
             * [showAdditionalText description] 显示内容扩展
             * @return {[type]} [description]
             */
            function showAdditionalText() {
                var additionalText = [];
                additionalText.push($scope.list.ADDITIONALTEXTTOP);
                additionalText.push($scope.list.ADDITIONALTEXTBOTTOM);
                additionalText.push($scope.list.ADDITIONALTEXTLEFT);
                additionalText.push($scope.list.ADDITIONALTEXTRIGHT);
                $scope.data.additionalText = additionalText;
            }

            /**
             * [getKeyWords 获取关键词]
             *
             * @return  {[type]}
             *   [return description]
             */
            function getKeyWords() {
                $scope.list.KEYWORDS = '';
                angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                    if (index != $scope.data.KEYWORDS.length - 1) {
                        $scope.list.KEYWORDS += data.name + ';';
                    } else {
                        $scope.list.KEYWORDS += data.name;
                    }
                });
            }

            // 可视化选择弹窗
            $scope.visualChooseWindow = function () {
                trsSelectDocumentService.trsSelectDocument(
                    {
                        siteid: $scope.status.siteid,
                        relNewsData: angular.copy($scope.data.relNewsSelectedItems),
                        position: $state.params.wzplatform,
                        showMetadaId: true,
                        platform: 1,
                    },
                    function (result) {
                        angular.forEach(result, function (value, key) {
                            value.METADATAID = value.metadataId;
                            value.TITLE = value.title;
                        });
                        $scope.data.relNewsSelectedItems = result;
                    },
                );
            };

            // 删除相关新闻
            $scope.relNesDelete = function (curIndex) {
                $scope.data.relNewsSelectedItems.splice($scope.data.relNewsSelectedItems.indexOf(curIndex), 1);
            };

            /**
             * [save description] 保存稿件
             * @param  {[type]} type [description] 是否直接保存
             * @return {[type]}      [description]
             */
            $scope.save = function (type) {
                // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
                type = angular.isDefined(type) ? type : true;
                var defer = $q.defer();
                save(type).then(
                    function () {
                        if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'websitenews') {
                            if (type === true) {
                                editIsLock.lockDraft($state.params.wzmetadataid);
                            }
                            getVersion($scope.list.METADATAID).then(function () {
                                if (angular.isDefined($state.params.wzchnldocid)) {
                                    var params;
                                    if ($scope.status.isFusionEditor) {
                                        params = {
                                            serviceid: 'mlf_fusioncreate',
                                            methodname: 'getWebFusionDoc',
                                            sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                                        };
                                    } else {
                                        params = {
                                            serviceid: 'mlf_website',
                                            methodname: 'getNewsDoc',
                                            ChnlDocId: $state.params.wzchnldocid,
                                            ChannelId: $state.params.wzchannelid,
                                            SiteId: $state.params.wzsiteid,
                                            MetaDataId: $state.params.wzmetadataid,
                                        };
                                    }
                                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                                        function (data) {
                                            $scope.list.VIDEOREL = data.VIDEOREL;
                                            var ue = UE.getEditor('ueditor');
                                            ue.ready(function () {
                                                // ue.setContent(
                                                //     data.HTMLCONTENT.replace(
                                                //         /<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g,
                                                //         '<hr ispageseparator="true"/>'
                                                //     )
                                                // );
                                                $scope.data.initContent = ue.getContent();
                                                ueditorService.saveToLocal(
                                                    $scope.list.METADATAID,
                                                    'website',
                                                    data.HTMLCONTENT,
                                                    $scope.data.lastVersionid,
                                                );
                                                // $scope.newsForm.$setPristine();
                                                if (!$scope.status.isFusionEditor) {
                                                    editcenterRightsService
                                                        .getRightsofBigFace($state.params.wzsiteid, 'website.trace')
                                                        .then(function (data) {
                                                            $scope.status.bigFaceRights = !!data['website.trace.chakan'] ? 'true' : 'false';
                                                        });
                                                }

                                                defer.resolve();
                                            });
                                            $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                                            reWriteAttachFile(data);
                                        },
                                        function () {
                                            defer.resolve();
                                        },
                                    );
                                }
                            });
                        } else {
                            getVersion($scope.list.METADATAID).then(function () {
                                ueditorService.saveToLocal($scope.list.METADATAID, 'website', $scope.list.HTMLCONTENT, $scope.data.lastVersionid);
                            });
                            defer.resolve();
                        }
                    },
                    function (error) {
                        // 第二步
                        defer.reject(error);
                    },
                );
                return defer.promise;
            };

            /* 保存并送审*/
            $scope.webCompileSend = function () {
                saveSend();
            };

            /* 待编平台直接签发*/
            $scope.webCompileSignDirect = function () {
                let params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'webDaiBianPublish'
                }
                singDirect(params);
            };

            /* 待编平台定时签发*/
            $scope.webCompileSignTiming = function () {
                if ($scope.status.isSecondReview === true) {
                    modalDialog.alertType('无法进行操作', '包含二次送审流程中的稿件,不能定时签发', 'warning', 'confirm', false);
                    return;
                }
                var array = [$scope.list];
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming(array, true).then(
                    function () {
                    },
                    function () {
                        singTiming();
                    },
                );
            };

            /* 待审平台直接签发*/
            $scope.webPendingSignDirect = function () {
                // $scope.save(false).then(function(data) {
                // $scope.params.serviceid = 'mlf_websiteoper';
                // $scope.params.methodname = 'webDaiShenPublish';
                let params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'webDaiShenPublish'
                }
                singDirect(params);
                // });
            };

            /* 待审平台定时签发*/
            $scope.webPendingSignTiming = function () {
                if ($scope.status.isSecondReview === true) {
                    modalDialog.alertType('无法进行操作', '包含二次送审流程中的稿件,不能定时签发', 'warning', 'confirm', false);
                    return;
                }
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming([$scope.list], true).then(
                    function () {
                        // 
                    },
                    function () {
                        singTiming();
                    },
                );
            };

            /* 待审平台退稿*/
            $scope.webPendingKill = function () {
                rejection();
            };

            /* 已签发平台保存并发布*/
            $scope.webSignPublish = function () {
                let params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'webYiQianPublish'
                }
                singDirect(params, true);
            };

            /**
             * [webSignSecondReview description] 已签发平台二次审签
             * @return {[type]} [description]
             */
            $scope.webSignSecondReview = function () {
                if ($scope.status.isSecondReview === true) {
                    modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                    return;
                }
                modalDialog.confirmModal('二次送审', '确认送审稿件', function () {
                    websiteSecondReview();
                });
            };

            /**
             * [websiteSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
             * @param  {[type]} metadataid [description]
             * @return {[type]}            [description]
             */
            function websiteSecondReview() {
                saveContent($scope.list); // 保存文本内容
                $validation.validate($scope.newsForm.authorForm);
                $scope.newsForm.$pending = {};
                $validation
                    .validate($scope.newsForm)
                    .success(function () {
                        sensitiveWordCheckService.sensitiveWords($scope).then(
                            function (sensitiveWords) {
                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                // 校验敏感词
                                $scope.newsForm.$setPristine();
                                // 保存前处理保存属性
                                var list = dealAttribute();
                                list.serviceid = 'mlf_website';
                                list.methodname = 'makeNewDuplication';
                                list.MetaDataId = list.METADATAID;
                                list.ChannelId = list.CHANNELID;
                                delete list.METADATAID; // 传参类型为驼峰型，删除之前纯大写字段；
                                delete list.CHANNELID;
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                    function (data) {
                                        if (data.ISSUCCESS == 'true') {
                                            getVersion($scope.list.METADATAID).then(function () {
                                                var params = {
                                                    serviceid: 'mlf_website',
                                                    methodname: 'getNewsDoc',
                                                    ChnlDocId: $state.params.wzchnldocid,
                                                    ChannelId: $state.params.wzchannelid,
                                                    SiteId: $state.params.wzsiteid,
                                                    MetaDataId: $state.params.wzmetadataid,
                                                };
                                                $scope.loadingPromise = trsHttpService
                                                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                                    .then(function (data) {
                                                        var ue = UE.getEditor('ueditor');
                                                        ue.ready(function () {
                                                            ue.setContent(data.HTMLCONTENT);
                                                            editcenterRightsService
                                                                .getRightsofBigFace($state.params.wzsiteid, 'website.trace')
                                                                .then(function (data) {
                                                                    $scope.status.bigFaceRights = !!data['website.trace.chakan'] ? 'true' : 'false';
                                                                });
                                                            ueditorService.saveToLocal(
                                                                $scope.list.METADATAID,
                                                                'website',
                                                                data.HTMLCONTENT,
                                                                $scope.data.lastVersionid,
                                                            );
                                                            modalDialog.alertType(
                                                                '二次送审成功',
                                                                '',
                                                                'success',
                                                                false,
                                                                function () {
                                                                    $scope.status.isSecondReview = true;
                                                                    storageListenerService.addListenerToWebsite('secondReview');
                                                                    $window.close();
                                                                },
                                                                '',
                                                                1500,
                                                            );
                                                        });
                                                    });
                                            });
                                        } else {
                                            modalDialog.alertType('二次送审失败', data.message, 'error', 'confirm');
                                        }
                                    },
                                    function (data) {
                                        $scope.status.openBtn = true;
                                        // modalDialog.alertType("二次送审失败", data.message, "error", "confirm");
                                    },
                                );
                            },
                            function () {
                                $scope.status.isCheckSensitiveWords = Math.random();
                            },
                        );
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.newsForm); // 定位输入错的表单位置
                    });
            }

            /**
             * [close description]页面关闭
             * @return {[type]} [description]
             */
            $scope.close = function () {
                closeCurrView();
            };

            /**
             * [closeCurrView description]关闭页面方法
             *
             * @return  {[type]}  [return description]
             */
            function closeCurrView() {
                editingCenterService
                    .closeWinow($scope.newsForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                    .then(
                        function () {
                            $scope.save(false).then(function () {
                                storageListenerService.addListenerToWebsite('save');
                                editIsLock.normalLock($state.params.wzmetadataid).then(function (data) {
                                    $window.close();
                                });
                            });
                        },
                        function () {
                            angular.isDefined($state.params.wzmetadataid)
                                ? editIsLock.normalLock($state.params.wzmetadataid).then(function (data) {
                                    $window.close();
                                })
                                : $window.close();
                        },
                    );
            }

            /**
             * [aboutVideoCloseView description]被视频影响的衍生出来的关闭页面方法（含提醒）
             *
             * @param   {[type]}  bigWord       [bigWord description]
             * @param   {[type]}  smallWord     [smallWord description]
             * @param   {[type]}  status        [status description]
             * @param   {[type]}  hasCancelBtn  [hasCancelBtn description]
             *
             * @return  {[type]}                [return description]
             */
            function aboutVideoCloseView(bigWord, smallWord, status, hasCancelBtn) {
                if ($scope.newsForm.$dirty || ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent()) {
                    closeCurrView();
                } else {
                    modalDialog.alertType(bigWord, smallWord, status, hasCancelBtn, function () {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                }
            }

            /* 预览*/
            $scope.preview = function () {
                $scope.save(false).then(function (data) {
                    editIsLock.lockDraft($state.params.wzmetadataid);
                    preview();
                });
            };

            /**
             * [preview description]保存预览
             *
             * @return  {[type]}  [return description]
             */
            function preview() {
                editingCenterService.draftPublish($state.params.wzchnldocid).then(
                    function () {
                    },
                    function () {
                        editIsLock.lockDraft($state.params.wzmetadataid);
                    },
                );
            }

            /**
             * [revise description] 修订
             * @return {[type]} [description]
             */
            $scope.revise = function () {
                modalDialog.confirmModal('修订', '确认修订?', function () {
                    save().then(
                        function () {
                            var params = {
                                serviceid: 'mlf_modifydoc',
                                methodname: 'paperModifyDocsFinished',
                                PaperDocIds: $state.params.wzmetadataid,
                            };
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                                function (data) {
                                    modalDialog.alertType(
                                        '修订成功',
                                        '',
                                        'success',
                                        false,
                                        function () {
                                            storageListenerService.addListenerToNewspaper('xiuding');
                                            $window.close();
                                        },
                                        '',
                                        1500,
                                    );
                                },
                                function (data) {
                                    editIsLock.lockDraft($state.params.wzmetadataid);
                                },
                            );
                        },
                        function () {
                            editIsLock.lockDraft($state.params.wzmetadataid);
                        },
                    );
                });
            };

            /**
             * [save description]保存
             *
             * @param   {[type]}  flag  [flag description]
             *
             * @return  {[type]}        [return description]
             */
            function save(flag) {
                // flag用于调用保存服务后是否弹出成功窗口判断
                var deferred = $q.defer();
                $scope.status.isedit = !!$state.params.wzmetadataid;
                saveContent($scope.list); // 获取编辑器内容
                $validation.validate($scope.newsForm.authorForm);
                $scope.newsForm.$pending = {};
                $validation
                    .validate($scope.newsForm)
                    .success(function () {
                        modalDialog.isSecretInformation(
                            $state.params.wzmetadataid,
                            function () {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function (sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        $scope.newsForm.$setPristine();
                                        var list = dealAttribute();
                                        list.ATTACHFILE = JSON.stringify($scope.getAppendixList());
                                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                            function (data) {
                                                $scope.data.METADATAID = data.METADATAID;
                                                if (!$scope.status.isedit) {
                                                    $scope.status.isedit = false;
                                                } else {
                                                    $scope.status.isedit = true;
                                                }
                                                dealWithDataAfterSave(data, flag);
                                                beforeonload.refresh($scope);
                                                deferred.resolve(data);
                                            },
                                            function (data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            },
                                        );
                                    },
                                    function () {
                                        $scope.status.isCheckSensitiveWords = Math.random();
                                        deferred.reject();
                                    },
                                );
                            },
                            function () {
                                deferred.reject();
                            },
                            $scope.status.isFusionEditor,
                        );
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.newsForm, $element, $scope); // 定位输入错的表单位置
                        // 第一步
                        deferred.reject({ plat: '网站' });
                    });
                return deferred.promise;
            }

            /**
             * [examAttachFile description]检测attachFile字段,存在为空的字段删除
             * @return {[type]} [description]
             */
            function examAttachFile() {
                if ($scope.list.ATTACHFILE === '') {
                    return;
                }
                angular.forEach($scope.list.ATTACHFILE, function (value, key) {
                    if (value.appFile === '') {
                        $scope.list.ATTACHFILE.splice($scope.list.ATTACHFILE.indexOf(value), 1);
                    }
                });
            }

            /**
             * [saveSend description]保存送审函数
             *
             * @return  {[type]}  [return description]
             */
            function saveSend() {
                newMediaService.trial($scope, websiteConst.trial).then((opinion) => {
                    $scope.save(false).then(function () {
                        $scope.params.CurrChnlId = $state.params.wzchannelid;
                        $scope.params.opinion = opinion;
                        let trialParams = angular.extend($scope.params, websiteConst.trial);
                        messagePublishService.publish('doEditPageOperation', trialParams);
                    });
                });
            }

            /**
             * [singDirect description]直接签发函数
             *
             * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
             * @param   {[type]}  params  [isSaveAndPublish description] 各个流程的签发接口名
             * 
             * @return  {[type]}                    [return description]
             */
            function singDirect(params, isSaveAndPublish) {
                var array = [$scope.list];
                if (isSaveAndPublish) {
                    privateSign(params);
                } else {
                    sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, 2).then(
                        function () {
                            privateSign(params);
                        },
                        function () {
                            privateSign(params);
                        },
                    );
                }

                /**
                 * [privateSign description]签发
                 * @param   {[type]}  params  [isSaveAndPublish description] 各个流程的签发接口名
                 * @return  {[type]}  [return description]
                 */
                function privateSign(params) {
                    $scope.loadingPromise = newMediaService.sign($scope, '', function (params, array) {
                        var ChnlDocIds = [];
                        var ObjectIds = [];
                        for (var i = 0; i < array.length; i++) {
                            ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                            ObjectIds.push(array[i].DOC.CHNLDOCID);
                        }
                        params.ChnlDocIds = ChnlDocIds.join(',');
                        params.ObjectIds = ObjectIds.join(',');
                    }).then(function () {
                        $scope.save(false).then(function (data) {
                            messagePublishService.publish('doEditPageOperation', angular.extend($scope.params, params));
                        });
                    });
                }
            }

            /**
             * [singTiming description]定时签发函数
             *
             * @return  {[type]}  [return description]
             */
            function singTiming() {
                var methodname = ['webDaiBianTimingPublish', 'webDaiShenTimingPublish'];
                $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
                    $scope.save(false).then(() => {
                        let signParams = {
                            serviceid: 'mlf_websiteoper',
                            methodname: methodname[$state.params.wzplatform],
                            ObjectIds: $scope.list.CHNLDOCID,
                            ChnlDocIds: $scope.list.CHNLDOCID,
                            MetaDataIds: $scope.list.METADATAID,
                        };
                        messagePublishService.publish('doEditPageOperation', signParams);
                    });
                });
            }

            /**
             * [rejection description]退稿函数
             *
             * @return  {[type]}  [return description]
             */
            function rejection() {
                newMediaService.rejection($scope, websiteConst.rejection).then((opinion) => {
                    $scope.save(false).then(function () {
                        $scope.params.Opinion = opinion;
                        $scope.params.CHNLDOCIDS = $state.params.wzchnldocid;
                        let KillParams = angular.extend($scope.params, websiteConst.rejection);
                        messagePublishService.publish('doEditPageOperation', KillParams);
                    });
                });
                // modalDialog.inputModel(
                //     '是否确认撤稿',
                //     '撤稿原因(可选)',
                //     function(content) {
                //         $scope.params.Opinion = content;
                //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get', false).then(
                //             function() {
                //                 modalDialog.alertType(
                //                     '撤稿成功',
                //                     '',
                //                     'success',
                //                     false,
                //                     function() {
                //                         storageListenerService.addListenerToWebsite('reject');
                //                         $window.close();
                //                     },
                //                     '',
                //                     1500,
                //                 );
                //             },
                //             function() {
                //                 editIsLock.lockDraft($state.params.wzmetadataid);
                //             },
                //         );
                //     },
                //     '',
                //     function() {
                //         editIsLock.lockDraft($state.params.wzmetadataid);
                //     },
                // );
            }

            /**
             * [initBtnArray description]初始化底部功能按钮
             *
             * @return  {[type]}  [return description]
             */
            function initBtnArray() {
                if ($scope.status.isawaitrevise) {
                    // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                    addBtn();
                    return;
                }
                if (!$scope.status.isFusionEditor) {
                    // 所需权限初始化
                    $scope.webSiteBtns = initWebsiteNewsService.initWebSitedBtns()[$state.params.wzplatform];
                    // 查询权限方法
                    $scope.methodArrary = ['web.daibian', 'web.daishen', 'web.yiqianfa'];
                    initeditctrBtnsService.initWebsiteData($state.params.wzchannelid, $scope.methodArrary[$state.params.wzplatform])
                        .then(function (data) {
                            $scope.dictionaryBtn = [
                                websiteBtnService.initWebCompBtn(),
                                websiteBtnService.initWebPenBtn(),
                                websiteBtnService.initSingBtn(),
                            ];
                            initeditctrBtnsService.initBtns(data, $scope.dictionaryBtn[$state.params.wzplatform]).then((btns) => {
                                $scope.btnStatus = btns;
                                $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.webSiteBtns);
                                addBtn();
                            });
                            // 查看痕迹按钮权限
                            editcenterRightsService.getRightsofBigFace($state.params.wzsiteid, 'website.trace').then(function (data) {
                                $scope.status.bigFaceRights = !!data['website.trace.chakan'] ? 'true' : 'false';
                            });
                        });
                }
            }

            /**
             * [addBtn description]新增预览与关闭按钮
             *
             * @return  {[type]}  [return description]
             */
            function addBtn() {
                $scope.arrayBtn = $scope.arrayBtn ? $scope.arrayBtn : [];
                if ($state.params.wzplatform == 2) {
                    return;
                }
                var OPERDESC = ['保存', '保存'];
                var OPERFUN = ['save', 'save'];
                $scope.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.wzplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.wzplatform],
                });
                // $scope.arrayBtn.push({
                //     RIGHTINDEX: "close",
                //     OPERDESC: "关闭",
                //     OPERNAME: "",
                //     OPERFUN: "close"
                // });
            }

            /**
             * [politicalCommonSense description]正文政治常识校验
             * @return {[type]} [description]
             */
            $scope.politicalCommonSense = function () {
                editingCenterService.checkoutDraft(ueditorService.bindContent()).then(function (data) {
                    if (data.content[0].resultInfo.length > 0) {
                        var ue = UE.getEditor('ueditor');
                        ue.setContent(ueditorService.handlingSensitiveInf(data, ue.getContent()));
                    }
                });
            };

            /**
             * [loadDirective description]
             *
             * @return  {[type]}  [return description]
             */
            function loadDirective() {
                var defer = $q.defer();
                editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                if ($state.params.issave === undefined || $state.params.issave === '0') {
                    // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                    LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                        var ueditor =
                            '<ueditor class="newEditor" edit-flag="editFlag" versionid="data.lastVersionid" type="{{\'website\'}}" infullscreen="status.infullscreen" list="list" has-content="status.hasContent"></ueditor>';
                        ueditor = $compile(ueditor)($scope);
                        $element.find('ueditorLocation').append(ueditor);
                        var ue = UE.getEditor('ueditor');
                        $scope.status.support.content = $scope.list.CONTENT;
                        ue.ready(function () {
                            ue.addListener('keydown', function (type, event) {
                                if (event.keyCode === 13) {
                                    $scope.status.support.content = ue.getContentTxt();
                                }
                            });
                            defer.resolve();
                        });
                        var supportCreation =
                            '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'2\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                        supportCreation = $compile(supportCreation)($scope);
                        $element.find('supportcreation').append(supportCreation);
                    });
                } else {
                    defer.resolve();
                }
                if (!$scope.status.isFusionEditor) {
                    var draftList =
                        '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                }
                return defer.promise;
            }

            /**
             * [getVersion description]获取流程版本与操作日志app新闻
             *
             * @param   {[type]}  id  [id description]
             *
             * @return  {[type]}      [return description]
             */
            function getVersion(id) {
                var deferred = $q.defer();
                var metadataid = angular.isDefined(id) ? id : $state.params.wzmetadataid;
                metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
                editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                    function (data) {
                        $scope.data.version = data;
                        $scope.page = data.page;
                        $scope.data.copyVersion = data.copyArray;
                        $scope.status.hasTimeline = true;
                        $scope.data.lastVersionid = data.lastVersionid;
                        deferred.resolve();
                    },
                    function () {
                        deferred.resolve();
                    },
                );
                return deferred.promise;
            }

            /**
             * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
             * @param  {[type]}  key [description] 操作日志或流程版本的数据
             * @return {Boolean}     [description]
             */
            $scope.isShowVersion = function (key) {
                if (key === undefined) {
                    return false;
                } else {
                    for (var i in key) {
                        return true;
                    }
                    return false;
                }
            };

            /**
             * [getLoadMore description]操作日志加载更多
             * @return {[type]} [description]
             */
            $scope.getLoadMore = function () {
                $scope.page.CURRPAGE++;
                getVersion();
            };

            /**
             * [getComment description]获取评审意见
             *
             * @param   {[type]}  id        [id description]
             * @param   {[type]}  currPage  [currPage description]
             *
             * @return  {[type]}            [return description]
             */
            function getComment(id, currPage) {
                editingCenterService.getComment(id, currPage).then(function (data) {
                    $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                    $scope.data.comment.hasMore = data.hasMore;
                    for (var i in data.voiceObj) {
                        $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                    }
                });
            }

            /**
             * [getComment description]获取评审意见
             * @return {[type]} [description]
             */
            $scope.getLoadMoreComment = function () {
                $scope.data.comment.currPage += 1;
                getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
            };

            /**
             * [trustUrl description]信任url
             */
            $scope.trustUrl = $sce.trustAsResourceUrl;

            /**
             * [getChannel description]根据栏目ID获取栏目名称
             *
             * @return  {[type]}  [return description]
             */
            function getChannel() {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'getChannelPath',
                    ChannelId: $state.params.wzchannelid,
                    Burster: '>',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.CHANNEL = data.replace(/\"/g, '');
                });
            }

            /**
             * [doWithPicsOrAttach description]编辑中，初始化处理图片或者附件
             *
             * @param   {[type]}  array  [array description]
             *
             * @return  {[type]}         [return description]
             */
            function doWithPicsOrAttach(array) {
                // 处理READINGPICS字段为空数组的情况，防止相关图片框消失。
                if (array.length === 0) {
                    array = [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ];
                }
                return array;
            }

            /**
             * [saveContent description]获取编辑器内容
             *
             * @param   {[type]}  list  [list description]
             *
             * @return  {[type]}        [return description]
             */
            function saveContent(list) {
                if (!$scope.status.isFusionEditor) {
                    ueditorService.saveContent(list);
                    if ($scope.list.HTMLCONTENT === '') {
                        $timeout(function () {
                            // 表单校验手动触发
                            $scope.newsForm.content.$error.content = true;
                            $scope.newsForm.content.$valid = false;
                            $scope.newsForm.content.$invalid = true;
                            $scope.newsForm.$error.content = [$scope.newsForm.content];
                            $scope.newsForm.$valid = false;
                            $scope.newsForm.$invalid = true;
                        });
                    }
                }
            }

            /**
             * [dealAttribute description]处理保存时对象属性问题
             * @return {[type]} [description]
             */
            function dealAttribute() {
                saveAttachFile();
                examAttachFile();
                getKeyWords();
                $scope.status.openBtn = false;
                $scope.list.CUSTOMTIME = globleParamsSet.filterTime($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm');
                $scope.list.RELATEDNEWS = trsspliceString.spliceString($scope.data.relNewsSelectedItems, 'METADATAID', ',');
                var list = angular.copy($scope.list);
                // 标题回车处理成</br> 存入数据库里
                list.TITLE = list.TITLE.split('\n').join('<br />');
                // 处理相关图片数组，删除APPFILE属性值为空的对象元素。
                // list.READINGPICS = angular.copy(jsonArrayToStringService.clearEmptyObjects(list.READINGPICS, "APPFILE"));
                list.OUTLINEPICS = angular.copy(jsonArrayToStringService.clearEmptyObjects(list.OUTLINEPICS, 'APPFILE'));
                // 如果编辑过就传编辑后的内容，没有的话与原始标签一样
                // list.TAGIDS = $scope.data.tag.hasChoose ? trsspliceString.spliceString($scope.data.tag.selectTag, 'SPECAILTAGID', ',') : angular.copy(list.OLDTAGIDS);
                list.OLDTAGIDS = list.TAGIDS = trsspliceString.spliceString($scope.data.tag.selectTag, 'SPECAILTAGID', ',');
                // 稿件归属人
                list.OWNER = trsspliceString.spliceString($scope.data.ownerSelectedItems, 'USERID', ',');
                // 音视频
                list.VIDEOREL = dealMediaUploadAttribute();
                // 特约稿
                list.SPECIALDOC = $scope.data.SPECIALDOC;
                // 供稿作者
                list.CONTRIBUTORSAUTHER = $scope.data.userName;
                // 删除多余字段开始
                delete list.RELEVANTNEWS;
                delete list.RELEVANTOFFICIALS;
                delete list.OBJ_VERSION;
                delete list.LOG_OPERATION;
                delete list.CRDEPT;
                // 删除多余字段结束
                // 处理发稿单作者信息空数据提交问题
                if (
                    angular.isDefined(list.FGD_AUTHINFO[0]) &&
                    (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
                ) {
                    list.FGD_AUTHINFO = [];
                }
                list.SPECIALDOC = $scope.data.specialDoc;
                list.ORIGINALTYPE = $scope.data.originType;
                // 处理发稿单作者信息空数据提交问题
                if ($scope.status.isFusionEditor) {
                    delete list.ISNOPAYMENT;
                    delete list.FGD_EDITINFO;
                    delete list.FGD_AUTHINFO;
                    delete list.DOCGENRE;
                    delete list.NEWSSOURCES;
                    list.METADATAID = $state.params.wzmetadataid || '0';
                    list.serviceid = 'mlf_fusionwebsite';
                    list.methodname = 'saveVirtualNewsDoc';
                    list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
                } else {
                    list.serviceid = 'mlf_website';
                    list.methodname = 'saveImgTextDoc';
                }
                // JSON对象数组转字符串
                list = jsonArrayToStringService.jsonArrayToString(list);
                return list;
            }

            /**
             * [dealMediaUploadAttribute description]处理音视频上传属性
             *
             * @return  {[type]}  [return description]
             */
            function dealMediaUploadAttribute() {
                var params = [];
                angular.forEach($scope.status.audioVideoidsArray, function (value, key) {
                    params.push({
                        REMARKS: value.explain || '',
                        COMMENTS: value.comment || '',
                        URL: value.cloudUrl || '',
                        APPENDIXVIDEOID: value.appendixvideoid || '0',
                        AUDIOVIDEOID: value.id,
                        STORAGE: value.storage || '1',
                    });
                });
                return params.length > 0 ? JSON.stringify(params) : null;
            }

            /**
             * [dealWithDataAfterSave description]保存之后处理数据
             * @param  {[obj]} data [description]保存后返回的数据
             * @param  {[boolean]} flag [description]标识
             * @return {[type]}      [description]
             */
            function dealWithDataAfterSave(data, flag) {
                $scope.status.openBtn = true;
                $scope.status.isEditDraft = true;
                // 再次初始化标签相关的属性
                $scope.list.METADATAID = data.METADATAID;
                $scope.list.CHNLDOCID = data.CHNLDOCID;
                $state.params.wzmetadataid = angular.isDefined($state.params.wzmetadataid) ? $state.params.wzmetadataid : data.METADATAID;
                $state.params.wzchnldocid = angular.isDefined($state.params.wzchnldocid) ? $state.params.wzchnldocid : data.CHNLDOCID;
                $state.params.wzchannelid = angular.isDefined($state.params.wzchannelid) ? $state.params.wzchannelid : $scope.list.CHANNELID;
                initTagAfterSave();
                if (flag) {
                    if (!$scope.status.isFusionEditor) {
                        storageListenerService.addListenerToWebsite('save');
                        $state.transitionTo($state.current, $state.params, {
                            reload: false,
                        });
                        $timeout(function () {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                    }
                    // editingCenterService.upDateVideoRelation($scope.data.editorDetail, $scope.data.METADATAID, $scope.list.TITLE, $scope.status.isFusionEditor);
                } else {
                    $scope.params = {
                        MetaDataIds: $state.params.wzmetadataid,
                        CHNLDOCIDS: $state.params.wzchnldocid,
                        ObjectIds: $state.params.wzchnldocid,
                        ChannelId: $state.params.wzchannelid,
                        serviceid: 'mlf_websiteoper',
                    };
                }
            }

            /**
             * [getKeywordsOrAbstract description]提取关键词或摘要
             * @param  {[str]} type [description]关键词类型或摘要
             * @return {[type]}      [description]
             */
            $scope.getKeywordsOrAbstract = function (type) {
                var content = ueditorService.bindContent();
                if (content === '') {
                    modalDialog.alertType('请先填写稿件正文', '', 'warning', 'confirm');
                    return;
                }
                $scope.loadingPromise = editingCenterService.getKeywordsOrAbstract(type, content).then(
                    function (data) {
                        if (type === 'keywords') {
                            if (data !== '""') {
                                var arr = [];
                                var keywordsArray = data.substring(1, data.length - 1).split(';');
                                angular.forEach(keywordsArray, function (value, key) {
                                    arr.push({
                                        name: value,
                                    });
                                });
                                $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                                $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                                if ($scope.data.KEYWORDS.length > 10) {
                                    $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                                }
                            } else {
                                return;
                            }
                        }
                        if (type === 'abstract') {
                            $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                        }
                    },
                    function (data) {
                    },
                );
            };

            /** ********************************************附件上传开始**********************************************/
            /**
             * [selectFiles description]选择文件
             * @param  {[type]} files    [description]所有文件
             * @param  {[type]} file     [description]
             * @param  {[type]} newFiles [description]新增的文件
             * @return {[type]}          [description]
             */
            $scope.selectFiles = function (files, file, newFiles) {
                $scope.status.isUploaderFile = true;
                angular.forEach(newFiles, function (value, key) {
                    $scope.status.showFiles.push({
                        SRCFILE: newFiles[key].name,
                        APPDESC: newFiles[key].name,
                        FILEINFO: '等待上传',
                        FILE: newFiles[key],
                    });
                });
                $scope.fileSubmit();
            };

            /**
             * [getAttachFile description]为ATTACHFILE重新复制，可更改
             * @return {[type]} [description]null
             */
            function saveAttachFile() {
                $scope.list.ATTACHFILE = [];
                angular.forEach($scope.status.showFiles, function (value, key) {
                    if (value.FILEINFO === '上传成功') {
                        delete value.FILE;
                        $scope.list.ATTACHFILE.push(value);
                    }
                });
            }

            /**
             * [reWriteAttachFile description]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function reWriteAttachFile(data) {
                $scope.status.showFiles = angular.copy(data.ATTACHFILE);
                angular.forEach($scope.status.showFiles, function (value, key) {
                    value.FILEINFO = '上传成功';
                });
            }

            /**
             * [clearAllKeywords description]清空关键词
             * @return {[type]} [description]
             */
            $scope.clearAllKeywords = function () {
                $scope.data.KEYWORDS = [];
            };

            /**
             * [fileSubmit description]附件提交
             * @return {[type]} [description]
             */
            $scope.fileSubmit = function () {
                if (angular.isUndefined($scope.newsForm.$error.filename)) {
                    if ($scope.status.showFiles) {
                        angular.forEach($scope.status.showFiles, function (file, key) {
                            if (file.FILEINFO === '等待上传') {
                                Upload.upload({
                                    url: '/wcm/openapi/uploadImage', // uploadImage
                                    data: {
                                        file: file.FILE,
                                    },
                                }).then(
                                    function (resp) {
                                        if (resp.data.success) {
                                            file.FILEINFO = '上传成功';
                                            file.APPFILE = resp.data.imgName;
                                            file.url = resp.data.imgSrc;
                                        } else if (resp.data.error) {
                                            file.FILEINFO = '上传失败';
                                        }
                                    },
                                    function (resp) {
                                    },
                                    function (evt) {
                                        // file.progressPercentage = parseInt(100.0 * evt.loaded / evt.total) + '%';
                                        file.FILEINFO = '上传中';
                                    },
                                );
                                $scope.status.isUploaderFile = false;
                            }
                        });
                    }
                } else {
                    modalDialog.saveModel('附件上传失败', '附件填写有误', 'error', 'confirm');
                }
            };

            /**
             * [removeCurFile description]移除当前附件
             * @param  {[obj]} file  [description]被选中的附件
             * @param  {[num]} index [description]附件下标
             * @return {[type]}       [description]
             */
            $scope.removeCurFile = function (file, index) {
                $scope.status.showFiles.splice($scope.status.showFiles.indexOf(file), 1);
            };

            /** ********************************************附件上传结束*************************************************/
            /** *****************************************新闻稿图片相关操作**********************************************/
            /**
             * [addUploaderImg description]导读，概览图片上传
             *
             * @param   {[type]}  array  [array description]
             * @param   {[type]}  type   [type description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.addUploaderImg = function (array, type) {
                if (array.length > 9) {
                    modalDialog.alertType(type + '最多支持10张', '', 'error', 'confirm');
                    return;
                }
                array.push({
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                });
            };

            /**
             * [uploadImg description]导读，概览图片上传
             *
             * @return  {[type]}  [return description]
             */
            $scope.uploadImg = function () {
                if ($scope.list.OUTLINEPICS.length == 10) {
                    // 导读图片最多允许上传10张
                    return;
                }
                if ($scope.list.OUTLINEPICS[$scope.list.OUTLINEPICS.length - 1].relationId) {
                    $scope.list.OUTLINEPICS.push({
                        APPFILE: '',
                        APPDESC: '',
                        PERPICURL: '',
                    });
                }
            };

            /**
             * [deleteImgContainer description]删除图片容器
             * @param  {[obj]} item  [description]要删除的某项
             * @param  {[obj]} array [description]要删除的图片数组
             * @return {[type]}       [description]null
             */
            $scope.deleteImgContainer = function (item, array) {
                array.splice(array.indexOf(item), 1);
                if (array[array.length - 1].APPDESC == '' && array[array.length - 1].APPFILE == '') {
                    return;
                }
                array.push({
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                });
            };

            /**
             * [getCurrentLoginUser description]获取当前用户
             * @return {[type]} [description]
             */
            function getCurrentLoginUser() {
                var deferred = $q.defer();
                var userParams = {
                    serviceid: 'mlf_extuser',
                    methodname: 'findUserInfo',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'post').then(function (data) {
                    $scope.data.user = data;
                    deferred.resolve(data);
                });
                return deferred.promise;
            }

            /**
             * [queryRelatedNewsByKeyWords description] 查询相关新闻
             * @return {[type]} [description]
             */
            $scope.queryRelatedNewsByKeyWords = function () {
                var DocId = $state.params.wzmetadataid ? $state.params.wzmetadataid : 0;
                var keywords = [];
                keywords = trsspliceString.spliceString(angular.copy($scope.data.KEYWORDS), 'name', ';');
                if (keywords == '') {
                    $scope.data.relNewsSelectedItems = [];
                    modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                    return;
                }
                var params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryRelatedNewsByKeyWords',
                    MetaDataId: DocId,
                    ChannelId: $state.params.wzchannelid,
                    KeyWords: keywords,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var ralNewsLen = angular.copy($scope.data.relNewsSelectedItems).length;
                    if (ralNewsLen >= 5) {
                        return;
                    }
                    $scope.data.relNewsSelectedItems = darftRemove($scope.data.relNewsSelectedItems, data).splice(0, 5);
                    if ($scope.data.relNewsSelectedItems.length == 0) {
                        modalDialog.alertType('暂无关联稿件', '', 'warning', false);
                    }
                });
            };
            // 清空相关联稿件
            $scope.cleanRelatedNews = function () {
                $scope.data.relNewsSelectedItems = [];
            };

            /**
             * [darftRemove description]  数组去重
             * @param  {[type]} selectArray [description]  当前数组
             * @param  {[type]} dataArray   [description]   再次请求出数组
             * @return {[type]}             [description]
             */
            function darftRemove(selectArray, dataArray) {
                var arr = selectArray.concat(dataArray);
                var lastArr = [];
                for (var i = 0; i < arr.length; i++) {
                    if (!unique(arr[i].METADATAID, lastArr)) {
                        lastArr.push(arr[i]);
                    }
                }
                return lastArr;
            }

            /**
             * [unique description]
             *
             * @param   {[type]}  n    [n description]
             * @param   {[type]}  arr  [arr description]
             *
             * @return  {[type]}       [return description]
             */
            function unique(n, arr) {
                for (var i = 0; i < arr.length; i++) {
                    if (n == arr[i].METADATAID) {
                        return true;
                    }
                }
                return false;
            }

            // 选择相关新闻或标签
            $scope.selectManuscript = function (item, type) {
                if (type == 'relNewsSelectedItems') {
                    if ($scope.data.selectNewArray.indexOf(item) < 0) {
                        $scope.data.selectNewArray.push(item);
                    } else {
                        $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                    }
                } else if (type == 'selectTagArray') {
                    if ($scope.data.selectTagArray.indexOf(item) < 0) {
                        $scope.data.selectTagArray.push(item);
                    } else {
                        $scope.data.selectTagArray.splice($scope.data.selectTagArray.indexOf(item), 1);
                    }
                }
            };

            /**
             * [selectAll description]相关新闻或标签全选
             *
             * @param   {[type]}  type  [type description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectAll = function (type) {
                if (type == 'selectTagArray') {
                    $scope.data.selectTagArray =
                        $scope.data.selectTagArray.length == $scope.data.tag.selectTag.length ? [] : [].concat($scope.data.tag.selectTag);
                } else if (type == 'selectNewArray') {
                    $scope.data.selectNewArray =
                        $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length
                            ? []
                            : [].concat($scope.data.relNewsSelectedItems);
                }
            };
            // 删除相关新闻或专题
            $scope.relNewsDelete = function (curIndex, type) {
                var index = $scope.data[type].indexOf(curIndex);
                $scope.data[type].splice(index, 1);
                if (type == 'relSubjectSelectedItems') {
                    if ($scope.data.selectNewArray.indexOf(curIndex) > -1) {
                        $scope.data.selectNewArray.splice(index, 1);
                    }
                    // $scope.data.relSubjectGroup.splice(index, 1);
                    // $scope.data.relSubjectSelectedGroup.splice(index, 1);
                }
                if (type == 'selectTagArray') {
                    var indexAll = $scope.data.tag.selectTag.indexOf(curIndex);
                    var indexSelect = $scope.data.tag.selectTag.indexOf(curIndex);
                    $scope.data.tag.selectTag.splice(indexAll, 1);
                    if ($scope.data.selectTagArray.indexOf(curIndex) >= 0) {
                        $scope.data.selectTagArray.splice(indexSelect, 1);
                    }
                    $scope.data.tag.hasChoose = true;
                    // $scope.data.relSubjectGroup.splice(index, 1);
                    // $scope.data.relSubjectSelectedGroup.splice(index, 1);
                }
            };

            /**
             * [manuscriptDelete description]相关新闻或标签全选
             * @param   {[type]}  type  [type description]
             * @return  {[type]}        [return description]
             */
            $scope.manuscriptDelete = function (type) {
                var index;
                if (type == 'tags') {
                    for (var i = 0; i < $scope.data.selectTagArray.length; i++) {
                        index = $scope.data.tag.selectTag.indexOf($scope.data.selectTagArray[i]);
                        $scope.data.tag.selectTag.splice(index, 1);
                    }
                    $scope.data.selectTagArray.length = 0;
                    $scope.data.tag.hasChoose = true;
                } else if (type == 'relNewsSelectedItems') {
                    for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                        index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                        $scope.data.relNewsSelectedItems.splice(index, 1);
                    }
                    $scope.data.selectNewArray.length = 0;
                }
            };

            /**
             * [saveChannelInfo description]保存稿件的栏目信息
             *
             * @param   {[type]}  data_2  [data_2 description]
             *
             * @return  {[type]}          [return description]
             */
            function saveChannelInfo(data_2) {
                $scope.CHANNEL = data_2[0].CHANNELPATH;
                $scope.list.CHANNELID = data_2[0].CHANNELID;
                template($scope.list.CHANNELID);
            }

            /**
             * [template description]模板
             *
             * @param   {[type]}  channelid  [channelid description]
             *
             * @return  {[type]}             [return description]
             */
            function template(channelid) {
                var deferred = $q.defer();
                var params = {
                    serviceid: 'mlf_websiteconfig',
                    methodname: 'getOptionalTemplates',
                    ObjectType: '101',
                    ObjectId: channelid,
                    TEMPLATETYPE: '2',
                    DocTemp: true,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function (data) {
                    var templateJson = data.DATA;
                    var channel = [];
                    channel.push({
                        name: '请选择模板',
                        value: 0,
                    });
                    for (var key in templateJson) {
                        channel.push({
                            name: templateJson[key].TEMPNAME,
                            value: parseInt(templateJson[key].TEMPID),
                        });
                        if (templateJson[key].DEFAULTTEMP == 1 && !$state.params.wzchnldocid) {
                            $scope.list.TEMPNAME = {
                                name: templateJson[key].TEMPNAME,
                                value: templateJson[key].TEMPID,
                            };
                        }
                    }
                    $scope.templateJson = channel;
                    deferred.resolve($scope.templateJson);
                });
                return deferred.promise;
            }

            /**
             * [chooseTag description]选择标签
             * @return {[type]} [description]
             */
            $scope.chooseTag = function () {
                websiteService.subjectModel($state.params.wzmetadataid, $state.params.wzchannelid, $scope.data.tag.selectTag, function (result) {
                    $scope.data.tag.hasChoose = true;
                    $scope.data.tag.selectTag = result.selectedArray;
                });
            };

            /**
             * [chooseTag description]请求当前稿件的标签
             * @return {[type]} [description]
             */
            function getCurrDraftTag() {
                var params = {
                    serviceid: 'mlf_tag',
                    methodname: 'queryTagsFromViewData',
                    metaDataId: $state.params.wzmetadataid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    // angular.forEach(data, function(value, key) {
                    $scope.data.tag.selectTag = data;
                    // });
                });
            }

            /**
             * [initTagAfterSave description]保存之后再次初始化标签需要的属性
             * @return {[type]} [description]
             */
            function initTagAfterSave() {
                $scope.data.tag.hasChoose = false;
                // $scope.data.tag.selectTag = [];
            }

            /**
             * [chooseAscription description]选择稿件归属人
             *
             * @return  {[type]}  [return description]
             */
            $scope.chooseAscription = function () {
                websiteService.ascriptionModel($scope.data.ownerSelectedItems, function (result) {
                    $scope.data.ownerSelectedItems = result.selectedArray;
                });
            };

            /**
             * [deleteAscription description] 删除稿件归属人
             * @param  {[type]} index [description] 序列
             * @return {[type]}       [description]
             */
            $scope.deleteAscription = function (index) {
                $scope.data.ownerSelectedItems.splice(index, 1);
            };

            /**
             * [openPersonalVersionTime description] 打开流程版本详情页
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.openPersonalVersionTime = function (item) {
                var path = $scope.data.path[item.MEDIATYPE];
                var params = {};
                if (!!$state.params.iwometadataid) {
                    geRelatedversion($state.params.iwometadataid, item.VERSIONNUM).then(function (data) {
                        var params = {
                            // 融合
                            metadataid: $state.params.iwometadataid,
                            iwoobjectversionid: item.OBJECTVERSIONID,
                            wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                            bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                            appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                            wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                            versionum: item.VERSIONNUM,
                        };
                        item.url = $state.href(path, params);
                        var url = item.url;
                        $window.open(url);
                    });
                } else {
                    var objName = $scope.data.versionName[item.MEDIATYPE];
                    params[objName] = item.OBJECTVERSIONID;
                    params['metadataid'] = $state.params.wzmetadataid;
                    item.url = $state.href(path, params);
                    var url = item.url;
                    $window.open(url);
                }
            };

            /**
             * [geRelatedversion description] 融合稿获取关联流程版本
             * @param  {[type]} MetaDataId [description]
             * @param  {[type]} num        [description]
             * @return {[type]}            [description]
             */
            function geRelatedversion(MetaDataId, num) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodname: 'getObjversionByDoc',
                    METADATAID: MetaDataId,
                    VersionNum: num,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /* 融合编辑器额外功能开始*/
            if ($scope.status.isFusionEditor) {

                /**
                 * [pageCantEdit description] 已提交渠道编辑页不能编辑
                 * @param  {[type]} type [description] 稿件信息或属性信息
                 * @return {[type]}      [description]
                 */
                $scope.pageCantEdit = function (type) {
                    $timeout(function () {
                        if (type == 'manuscriptInfo') {
                            var manuHeight = $('.website_manuscript_info').height();
                            var manuWidth = $('.website_manuscript_info').width();
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height(manuHeight)
                                .width(manuWidth);
                            $('.website_manuscript_info').resize(function () {
                                $('.pageCantEdit')
                                    .find('.cantEditPart')
                                    .height($(this).height());
                            });
                        } else if (type == 'attrInfo') {
                            var attrHeight = $('.website_attr_info').height();
                            var attrWidth = $('.website_attr_info').width();
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height(attrHeight)
                                .width(attrWidth);
                            $('.website_attr_info').resize(function () {
                                $('.pageCantEdit')
                                    .find('.cantEditPart')
                                    .height($(this).height());
                            });
                        }
                    }, 300);
                };

                /**
                 * [initData description] 融合编辑器切换渠道时的初始化数据
                 * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
                 * @return {[type]} [description]
                 */
                   $scope.initData = function (dealWithListFun) {
                    var defer = $q.defer();
                    if (angular.isDefined($state.params.wzchnldocid)) {
                        initEditData(dealWithListFun).then(function () {
                            editingCenterService.initAppendixUpload($scope);
                            defer.resolve();
                        });
                    } else {
                        initNewData(dealWithListFun).then(function () {
                            editingCenterService.initAppendixUpload($scope);
                            defer.resolve();
                        });
                    }
                    return defer.promise;
                };



                /**
                 * [loadFgd description] 加载发稿单
                 * @return {[type]} [description]
                 */
                $scope.loadFgd = function () {
                    var draftList =
                        '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                };
            }

            /* 融合编辑器额外功能结束*/

            /**
             * [关闭窗口]
             */
            $scope.closeWindow = function () {
                editingCenterService.closeWindow('app', $scope);
            };

            /**
             * [保存内容并关闭窗口]
             */
            $scope.saveAndClose = function () {
                $scope.save(false).then(function () {
                    window.close();
                });
            };
        },
    ]);
